import {InlineDatumReactComponentProps} from '@stripe-internal/inline-data';
import {useCallback, useState, useRef} from 'react';
import {v4 as uuid} from 'uuid';
import SendUsAnEmailSection, {
  EmailForm,
  FollowUpEmailClientErrors,
} from '../helpers/SendUsAnEmailSection';

export type ValueProps = {
  email_form?: EmailForm;
  error_code?: FollowUpEmailClientErrors;
  is_email_form_submitted?: boolean;
  show_cc_emails_field?: boolean;
  existing_cc_emails?: string[];
};

export function FollowUpEmail(props: InlineDatumReactComponentProps) {
  const {datum, action, isDone, onDone, actionError} = props;
  const value = datum.value as ValueProps;
  const [isCancelled, setIsCancelled] = useState(false);

  const {
    email_form: emailForm,
    error_code: errorCode,
    is_email_form_submitted: isEmailFormSubmitted,
    show_cc_emails_field: showCcEmailsField,
    existing_cc_emails: existingCcEmails,
  } = value;

  const nonce = useRef<string>(uuid()).current;

  const handleCancelForm = useCallback(() => {
    setIsCancelled(true);
    onDone({
      type: 'success',
    });
  }, [onDone, setIsCancelled]);

  return (
    <SendUsAnEmailSection
      action={action}
      nonce={nonce}
      handleCancelForm={handleCancelForm}
      emailForm={emailForm}
      isSectionVisible={!isCancelled}
      isEmailFormSubmitted={isDone || !!isEmailFormSubmitted}
      showUnauthenticatedEmailField={false}
      showCcEmailsField={showCcEmailsField}
      existingCcEmails={existingCcEmails}
      clientError={
        errorCode ? (errorCode as FollowUpEmailClientErrors) : undefined
      }
      serverError={actionError}
    />
  );
}
